import React from "react";
import BarLoader from "react-spinners/BarLoader";
import TextTransition, { presets } from "react-text-transition";
const TEXTS = [
    " Preparing your meals ",
    " Counting the calories",
    "Calculating the macros",
    "    Optimising menu   ",
];
export default class Step5 extends React.Component {
    constructor() {
        super(...arguments);
        this.intervalId = undefined;
        this.state = {
            index: 0
        };
    }
    componentDidMount() {
        this.intervalId = setInterval(() => {
            this.setState({
                index: this.state.index + 1
            });
        }, 3000);
    }
    componentWillUnmount() {
        clearTimeout(this.intervalId);
    }
    render() {
        const colour = "#000";
        const index = this.state.index;
        return (React.createElement("div", { className: "card card-body text-center" },
            React.createElement("h3", null, "Preparing your meals..."),
            React.createElement("div", null,
                React.createElement(BarLoader, { color: colour, loading: true, width: "60%", cssOverride: {
                        margin: "0 auto"
                    } }),
                React.createElement(TextTransition, { springConfig: presets.wobbly, className: "loading-text" }, TEXTS[index % TEXTS.length]))));
    }
}
